import { useEffect } from 'react'

import Cookie from 'js-cookie'
import { cache } from '@emotion/css'
import { CacheProvider } from '@emotion/react'
import { Provider as ModalProvider } from '@happyfresh/modal'
import { globalStyles } from '@happyfresh/theming'
import { useRouter } from 'next/router'
import { Provider as StoreProvider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import { Provider as IdentityProvider } from '@context/identity'
import store from '@config/redux-store'
import { datadogLogs } from '@datadog/browser-logs'
import runtimeConfig from '@config/runtime'

if (runtimeConfig.datadogKey) {
  datadogLogs.init({
    clientToken: runtimeConfig.datadogKey,
    site: 'datadoghq.com',
    forwardErrorsToLogs: false,
    sampleRate: 100,
    env: runtimeConfig.appStage,
    service: 'Webapp-HelpCenter'
  })
}

export function reportWebVitals ({ id, name, label, value }) {
  datadogLogs.logger.info('Web Vital', {
    webVital: {
      name,
      value: Math.round(name === 'CLS' ? value * 1000 : value),
      id
    }
  })
}

const Heima = ({ Component, pageProps }) => {
  const router = useRouter()
  const {
    query: { lang, clientType, country }
  } = router

  useEffect(() => {
    if (lang || clientType) {
      datadogLogs.setLoggerGlobalContext({
        clientType
      })

      router.replace(router.asPath.split('?')[0])
    }
  }, [lang, clientType])

  useEffect(() => {
    if (country && country !== 'auth') {
      Cookie.set('country', country.toUpperCase())
    }
  }, [country])

  return (
    <StoreProvider store={store}>
      <CacheProvider value={cache}>
        <ModalProvider>
          {globalStyles}
          <PersistGate
            persistor={store.__PERSISTOR}
            loading={<Component {...pageProps} />}
          >
            <IdentityProvider>
              <Component {...pageProps} />
            </IdentityProvider>
          </PersistGate>
        </ModalProvider>
      </CacheProvider>
    </StoreProvider>
  )
}

export default Heima
